import { FC } from 'react';
import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { i18nTB } from 'utils/shared/utils';
import { images } from 'constants/generic';

const TripBuilderClientFooter2: FC = () => {
  
  const { i18n } = useTranslation(undefined, { i18n: i18nTB });

  return (
    <footer className="tb2-footer" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <div className="tb2-footer-inner">
        <div className="tb2-footer-brand">
          {!!images?.logo108 && <img className="tb2-footer-logo" src={images.logo108} alt="flyeast" />}
        </div>

        <div className="tb2-footer-social">
          <button type="button" className="tb2-footer-social-btn" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebook} aria-hidden="true" />
          </button>
          <button type="button" className="tb2-footer-social-btn" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} aria-hidden="true" />
          </button>
          <button type="button" className="tb2-footer-social-btn" aria-label="WhatsApp">
            <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default TripBuilderClientFooter2;
